import HLS from 'hls-parser';
import logger from '../log';

const log = logger.getLogger(__filename);

type MasterPlaylist = HLS.types.MasterPlaylist;

type Variant = HLS.types.Variant;

function highestUnderMin(
  variants: Variant[],
  minVideoBitrate: number
): Variant | undefined {
  const filtered = variants.filter(v => v.bandwidth < minVideoBitrate);
  return filtered.length === 0
    ? undefined
    : filtered.reduce((acc, next) => {
        return next.bandwidth > acc.bandwidth ? next : acc;
      });
}

function lowestVariant(variants: Variant[]): Variant {
  return variants.reduce((acc, next) => {
    return next.bandwidth < acc.bandwidth ? next : acc;
  });
}

export default function stripBitrates(
  minVideoBitrate: number,
  maxVideoBitrate: number,
  masterPlaylist: MasterPlaylist
): MasterPlaylist {
  const { variants } = masterPlaylist;
  if (!variants) {
    log.info('Master playlist lacks variants. Nothing to filter');
    return masterPlaylist;
  }
  // copy the variants
  const originalVariants = [...variants];
  log.debug(
    'Original video bitrates: ',
    originalVariants.map(v => v.bandwidth)
  );
  // walk the variants
  const filtered = variants.filter(v => {
    return v.bandwidth >= minVideoBitrate && v.bandwidth <= maxVideoBitrate;
  });
  if (filtered.length === 0) {
    // find out if we need min or max
    const hum = highestUnderMin(originalVariants, minVideoBitrate);
    const lowest = lowestVariant(originalVariants);
    if (!hum || lowest.bandwidth > hum.bandwidth) {
      masterPlaylist.variants = [lowest];
    } else {
      masterPlaylist.variants = [hum];
    }
    log.debug(
      'Selected video bitrates: ',
      masterPlaylist.variants.map(v => v.bandwidth)
    );
    return masterPlaylist;
  } else {
    log.debug(
      'Selected video bitrates: ',
      filtered.map(v => v.bandwidth)
    );
    masterPlaylist.variants = filtered;
    return masterPlaylist;
  }
}
